/*
  Build-a-Box cart controller.

  Adds the two group-level actions that replace the per-line controls we hide on bundle lines
  (see assets/component-build-a-box-cart-branded.css for why they are hidden):

    [data-bab-remove-box]  removes every line of that box in one /cart/update.js call
    [data-bab-edit-box]    a plain link to the builder, handled by the browser

  Listeners are delegated from the document so they survive Dawn re-rendering the drawer or the cart
  section, and the script is safe to load on every page that renders cart lines.
*/
(function () {
  'use strict';

  var BUSY = 'data-bab-busy';

  /*
    Resolve a Section Rendering API id to its element in this document.

    The id we pass to the API is the key from the template JSON ("cart-items"), but Shopify renders
    the wrapper with the template prefixed in front of it, for example
    shopify-section-template--22079993348231__cart-items. Matching only the bare id silently finds
    nothing on /cart, so the suffix form is checked too.
  */
  function sectionEl(id) {
    return (
      document.getElementById('shopify-section-' + id) ||
      document.querySelector('[id^="shopify-section-"][id$="__' + id + '"]')
    );
  }

  function sectionIdsPresent() {
    // Only ask for sections that actually exist in this document, so the same code works in the
    // drawer, on /cart, and on any page that only carries the cart icon bubble.
    var candidates = [
      'cart-drawer',
      'cart-icon-bubble',
      'cart-items',
      'cart-footer',
      'main-cart-items',
      'main-cart-footer',
    ];
    var present = [];
    candidates.forEach(function (id) {
      if (sectionEl(id)) present.push(id);
    });
    if (document.querySelector('cart-drawer') && present.indexOf('cart-drawer') === -1) {
      present.push('cart-drawer');
    }
    return present;
  }

  function swapSection(id, html) {
    var host = sectionEl(id);
    if (!host || typeof html !== 'string') return false;
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    // The response wraps the section in the same prefixed id the live document uses.
    var source = parsed.getElementById(host.id) || parsed.querySelector('[id^="shopify-section-"][id$="__' + id + '"]');
    host.innerHTML = source ? source.innerHTML : html;
    return true;
  }

  function announce() {
    try {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'build-a-box-cart' });
      }
    } catch (e) {
      /* pub/sub is optional */
    }
  }

  function showError(button, message) {
    var header = button.closest('.bab-cart-group');
    if (!header) return;
    var slot = header.querySelector('[data-bab-group-error]');
    if (slot) {
      slot.textContent = message;
      slot.hidden = false;
    }
  }

  async function removeBox(button) {
    if (button.hasAttribute(BUSY)) return;
    var keys = (button.getAttribute('data-bab-keys') || '').split(',').filter(Boolean);
    if (!keys.length) return;

    button.setAttribute(BUSY, '');
    button.disabled = true;
    var original = button.textContent;
    button.textContent = button.getAttribute('data-bab-busy-label') || 'Removing...';

    var updates = {};
    keys.forEach(function (key) {
      updates[key] = 0;
    });

    var sections = sectionIdsPresent();
    var body = {
      updates: updates,
      sections: sections.join(','),
      sections_url: window.location.pathname,
    };

    try {
      var res = await fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify(body),
      });
      if (!res.ok) throw new Error('cart update failed: ' + res.status);
      var data = await res.json();

      announce();

      if (!data.sections) {
        window.location.reload();
        return;
      }

      var swapped = 0;

      // The drawer knows how to repaint itself and its icon bubble together.
      var drawer = document.querySelector('cart-drawer');
      if (drawer && data.sections['cart-drawer'] && typeof drawer.renderContents === 'function') {
        try {
          // Dawn leaves is-empty on the element; it must go before rendering or the drawer paints blank.
          drawer.classList.remove('is-empty');
          drawer.renderContents(data);
          swapped += 1;
        } catch (e) {
          /* fall through to the generic swap below */
        }
      }

      // The cart page sections still need swapping, and this page may well be /cart with a drawer
      // in the layout, so both paths run rather than one returning early.
      Object.keys(data.sections).forEach(function (id) {
        if (id === 'cart-drawer') return;
        if (swapSection(id, data.sections[id])) swapped += 1;
      });

      if (!swapped) window.location.reload();
    } catch (err) {
      button.removeAttribute(BUSY);
      button.disabled = false;
      button.textContent = original;
      showError(button, button.getAttribute('data-bab-error-label') || 'Could not remove the box. Please try again.');
    }
  }

  document.addEventListener('click', function (evt) {
    var button = evt.target.closest ? evt.target.closest('[data-bab-remove-box]') : null;
    if (!button) return;
    evt.preventDefault();
    removeBox(button);
  });
})();
